import React from 'react';
import { Link } from 'react-router-dom';
import '../components/styles.css';
import AnimatedSection from '../components/AnimatedSection';

const NotFoundPage = () => {
  return (
    <AnimatedSection>
      <main className="page-container-centered">
        <div className="container">
          <div className="not-found-content">
            <div className="error-code" aria-hidden="true">404</div>
            <h2>Halaman Tidak Ditemukan</h2>
            <p>Maaf, halaman yang Anda cari tidak ada atau mungkin telah dipindahkan.</p>
            <Link to="/" className="btn-hero">
              Kembali ke Beranda
            </Link>
          </div>
        </div>
      </main>
    </AnimatedSection>
  );
};

export default NotFoundPage;